import { apiClient } from '@/utils/api-client';
import { toNumber, toNumberOrNull } from '@/utils/number-operations';
import type {
  ApiLpAllocations,
  LpAllocations,
  LpAllocationsUpdate,
} from '@/types/lpAllocation';

function mapLpAllocations(dto: ApiLpAllocations): LpAllocations {
  return {
    fund_transaction_id: dto.fund_transaction_id,
    invested_amount: toNumber(dto.invested_amount),
    shares: toNumberOrNull(dto.shares),
    basis: dto.basis,
    is_editable: dto.is_editable,
    rows: dto.rows.map((row) => ({
      investor_fund_relationship_id: row.investor_fund_relationship_id,
      investor_id: row.investor_id,
      investor_name: row.investor_name,
      commitment_amount: toNumber(row.commitment_amount),
      amount: toNumber(row.amount),
      allocated_to_other_investments: toNumber(
        row.allocated_to_other_investments
      ),
    })),
  };
}

export const lpAllocationService = {
  async get(fundTransactionId: string): Promise<LpAllocations> {
    const dto = await apiClient.get<ApiLpAllocations>(
      `/fund-transactions/${fundTransactionId}/lp-allocations`
    );
    return mapLpAllocations(dto);
  },

  replace(
    fundTransactionId: string,
    update: LpAllocationsUpdate
  ): Promise<{ id: string }> {
    return apiClient.put(
      `/fund-transactions/${fundTransactionId}/lp-allocations`,
      update
    );
  },

  resetToProRata(fundTransactionId: string): Promise<void> {
    return apiClient.delete(
      `/fund-transactions/${fundTransactionId}/lp-allocations`
    );
  },
};
